import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import * as feedAdviceActions from '../store/feed-advice.actions';

@Injectable()
export class FeedAdviceOverviewResolver {
  constructor(private readonly store: Store<RootState>) {}

  resolve(route: ActivatedRouteSnapshot) {
    const path = route.pathFromRoot
      .map((v) => v.url.map((segment) => segment.toString()).join('/'))
      .join('/');
    if (path.indexOf('reference') > -1) {
      this.store.dispatch(feedAdviceActions.loadReferenceFeedAdvicesRequest());
    } else {
      this.store.dispatch(feedAdviceActions.loadFeedAdvicesRequest());
    }
    return of(true);
  }
}
